import styled from 'styled-components';
import Input from '../input/Input';
export const CustomPriceInput = styled.div `
  display: flex;

  border: ${({ theme, focused, hover }) => {
    const borderHover = hover
        ? theme.colors.borders.hover
        : theme.colors.borders.default;
    return `1px solid ${focused ? theme.colors.borders.pressed : borderHover}`;
}};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  box-shadow: ${({ theme, focused }) => (focused ? theme.shadows.xl : 'none')};
  border-radius: ${({ theme, borderTopFlat, borderBottomFlat }) => `${borderTopFlat ? 0 : theme.borderRadius.high} ${borderTopFlat ? 0 : theme.borderRadius.high} ${borderBottomFlat ? 0 : theme.borderRadius.high} ${borderBottomFlat ? 0 : theme.borderRadius.high}`};

  ${({ theme }) => {
    const backgroundColor = theme.colors.surface.hover;
    const borderColor = theme.colors.borders.hover;
    return theme.media.laptop `
    &:hover {
      background-color: ${backgroundColor}
      border: 1px solid ${borderColor}
    }
    `;
}}
  overflow: hidden;
`;
export const CustomInput = styled(Input) `
  flex: 1;
`;
//# sourceMappingURL=style.js.map